import { Box, TextField } from "@mui/material";

const QrDetailsView = ({
  values,
  setFieldValue,
  handleBlur,
  touched,
  errors,
}: any) => {
  return (
    <Box>
      <TextField
        fullWidth
        id="MID"
        label="MID"
        size="small"
        value={values.MID}
        onChange={(e) => setFieldValue("MID", e.target.value)}
        sx={{ mt: 1.5 }}
        onBlur={handleBlur}
        helperText={touched.MID && errors.MID ? errors.MID : ""}
        error={touched.MID && Boolean(errors.MID)}
        InputLabelProps={{ required: true }}
      />

      <TextField
        fullWidth
        id="Device_ID"
        label="Device ID"
        size="small"
        value={values.Device_ID}
        onChange={(e) => setFieldValue("Device_ID", e.target.value)}
        sx={{ mt: 1.5 }}
        onBlur={handleBlur}
        helperText={
          touched.Device_ID && errors.Device_ID ? errors.Device_ID : ""
        }
        error={touched.Device_ID && Boolean(errors.Device_ID)}
        InputLabelProps={{ required: true }}
      />

      <TextField
        fullWidth
        id="VPA"
        label="VPA"
        size="small"
        value={values.VPA}
        onChange={(e) => setFieldValue("VPA", e.target.value)}
        sx={{ mt: 1.5 }}
        onBlur={handleBlur}
        helperText={touched.VPA && errors.VPA ? errors.VPA : ""}
        error={touched.VPA && Boolean(errors.VPA)}
        InputLabelProps={{ required: true }}
      />

      <TextField
        fullWidth
        id="Location_id"
        label="Location ID"
        size="small"
        value={values.Location_id}
        onChange={(e) => setFieldValue("Location_id", e.target.value)}
        sx={{ mt: 1.5 }}
        onBlur={handleBlur}
        helperText={
          touched.Location_id && errors.Location_id ? errors.Location_id : ""
        }
        error={touched.Location_id && Boolean(errors.Location_id)}
        InputLabelProps={{ required: true }}
      />
    </Box>
  );
};

export default QrDetailsView;
